import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PublicLayout from "./PublicLayout";
import banner from "../images/banner.png";
import { aboutUsList } from "../constants/Constants";

export default function AboutUs() {
    const navigate = useNavigate();

    return (
        <PublicLayout activePage="About">
            <div className="upload-main">
                <button className="chpw-back" onClick={() => navigate(-1)}>
                    <ArrowLeft size={14} />
                    Back
                </button>

                <h1 className="upload-page-heading">About Us</h1>

                <div className="about-banner-wrap">
                    <img src={banner} alt="42Degrees" className="about-banner-img" />
                </div>

                <div className="about-entries">
                    {aboutUsList.map((item, index) => (
                        <p className="about-entry" key={index}>{item}</p>
                    ))}
                </div>
            </div>
        </PublicLayout>
    );
}
